import React from 'react';

interface RequiredLabelProps {
    text: string;
    required?: boolean;
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({ text, required = false }) => {
    if (!required) {
        return <>{text}</>;
    }

    return (
        <span>
            {text} <span style={{ color: 'red' }} aria-label="required">*</span>
        </span>
    );
};

export default RequiredLabel;
